import React, { Children } from "react";

const Status = ({label, isFailure = false, className}) => {
  return <span
    className={`${isFailure ? "bg-red-100 text-error-500 " : "bg-green-100 text-primary-800 "}rounded text-xs py-1 px-2 font-semibold tracking-wide whitespace-nowrap${className && ` ${className}`}`}>
    {label}
  </span>

}
export const Tag = ({label, className, ...props}) => {
  return <div className={`inline bg-blue-100 rounded text-sm text-rand-100 px-1 mr-1 mb-1 whitespace-nowrap${className && ` ${className}`}`} {...props}>
    {label}
  </div>

}
export default Status
